var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header flex-space-between" }, [
        _c("span", [
          _vm.gestionParPlan
            ? _c("span", [
                _c("span", [
                  _vm._v("Régime " + _vm._s(_vm.regimeNomGestionParPlan))
                ]),
                _c("span", { staticClass: "ml-4" }, [
                  _vm._v("Texture " + _vm._s(_vm.textureNomGestionParPlan))
                ])
              ])
            : _vm._e(),
          _vm.estSurPlanNeutre
            ? _c("span", [
                _vm._v(
                  "Ce menu est sur un plan Neutre il ne sera pas utilisé concrétement"
                )
              ])
            : _vm._e()
        ]),
        _c("span", [
          _c(
            "label",
            { staticClass: "label-checkbox" },
            [
              _c("span", { staticClass: "ml-2" }, [
                _vm._v("Afficher le menu en mode aperçu")
              ]),
              _c("ToggleButton", {
                staticClass: "ml-2 mt-1",
                attrs: {
                  color: { checked: "#16D39A", unchecked: "#CCCCCC" },
                  height: 12,
                  width: 20
                },
                model: {
                  value: _vm.mode,
                  callback: function($$v) {
                    _vm.mode = $$v
                  },
                  expression: "mode"
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "card-container" }, [
        _c(
          "div",
          {
            staticClass:
              "card card-minimal table-scroll height-responsive-menu-100"
          },
          [
            _c("div", { staticClass: "table-body-menu" }, [
              _c(
                "table",
                {
                  staticClass: "table table-borderless",
                  staticStyle: { "table-layout": "fixed" }
                },
                [
                  _c("thead", { staticStyle: { "z-index": "5" } }, [
                    _c(
                      "tr",
                      {
                        staticClass: "hover-inactif",
                        staticStyle: { background: "white" }
                      },
                      [
                        _vm._l(_vm.optionsJours, function(jour, i) {
                          return [
                            _vm.jourActif(jour.id)
                              ? _c("th", { key: i, attrs: { scope: "col" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-center-space-between"
                                    },
                                    [
                                      !_vm.lectureSeule
                                        ? [
                                            _c(
                                              "button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-modal",
                                                    rawName: "v-b-modal",
                                                    value:
                                                      "changerEffectif" +
                                                      jour.id +
                                                      i,
                                                    expression:
                                                      "'changerEffectif'+jour.id+i"
                                                  }
                                                ],
                                                staticClass:
                                                  "btn btn-primary btn-sm"
                                              },
                                              [
                                                _c("i", {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: {
                                                        content:
                                                          "Changer les effectifs du jour"
                                                      },
                                                      expression:
                                                        "{ content: 'Changer les effectifs du jour'}"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "fas fa-users cursor-pointer"
                                                })
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "b-modal",
                                        {
                                          attrs: {
                                            id: "changerEffectif" + jour.id + i,
                                            title: "Effectifs du jour",
                                            "ok-title": "Valider",
                                            "cancel-title": "Annuler",
                                            "no-close-on-backdrop": ""
                                          },
                                          on: {
                                            show: function($event) {
                                              return _vm.initEffectifsJour(
                                                jour.id
                                              )
                                            },
                                            ok: function($event) {
                                              return _vm.setEffectifsJour(
                                                jour.id,
                                                i
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("template", { slot: "default" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "container-fluid"
                                              },
                                              [
                                                _vm.regimeIds.length === 1
                                                  ? _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-12 flex-center-space-evenly"
                                                        },
                                                        [
                                                          _vm.estPasse(i)
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c("div", [
                                                                    _vm._v(
                                                                      "Effectif Servi par service"
                                                                    )
                                                                  ]),
                                                                  _c(
                                                                    "InputNumber",
                                                                    {
                                                                      key:
                                                                        "effectifServiJour" +
                                                                        jour.id,
                                                                      staticClass:
                                                                        "inputEffectif",
                                                                      attrs: {
                                                                        id:
                                                                          "effectifServiJour" +
                                                                          jour.id,
                                                                        typeFiltre:
                                                                          "quantiteEntiere"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.effectifServiJour,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.effectifServiJour = $$v
                                                                        },
                                                                        expression:
                                                                          "effectifServiJour"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "div",
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.estPasse(
                                                                      i
                                                                    )
                                                                      ? "Théorique"
                                                                      : "Effectif prévu"
                                                                  )
                                                                )
                                                              ]),
                                                              _c(
                                                                "InputNumber",
                                                                {
                                                                  key:
                                                                    "effectifJour" +
                                                                    jour.id,
                                                                  staticClass:
                                                                    "inputEffectif",
                                                                  attrs: {
                                                                    id:
                                                                      "effectifJour" +
                                                                      jour.id,
                                                                    typeFiltre:
                                                                      "quantiteEntiere",
                                                                    readonly: _vm.estPasse(
                                                                      i
                                                                    )
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.effectifJour,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.effectifJour = $$v
                                                                    },
                                                                    expression:
                                                                      "effectifJour"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm.effectifJour
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6"
                                                              },
                                                              [_vm._v("Régime")]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-3"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Effectif Servi"
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-3"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.estPasse(
                                                                      i
                                                                    )
                                                                      ? "Théorique"
                                                                      : "Effectif"
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._l(
                                                          _vm.regimeIds,
                                                          function(regimeId) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: regimeId,
                                                                staticClass:
                                                                  "row",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "10px"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-6",
                                                                    staticStyle: {
                                                                      "padding-top":
                                                                        "5px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.regimeNom(
                                                                          regimeId
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm.estPasse(i)
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col-3"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "InputNumber",
                                                                          {
                                                                            key:
                                                                              "effectifServi" +
                                                                              jour.id +
                                                                              regimeId,
                                                                            staticClass:
                                                                              "inputEffectif",
                                                                            attrs: {
                                                                              typeFiltre:
                                                                                "quantiteEntiere",
                                                                              zeroSiVide: true
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .effectifServiJour[
                                                                                  regimeId
                                                                                ],
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.effectifServiJour,
                                                                                  regimeId,
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "effectifServiJour[regimeId]"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-3"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "InputNumber",
                                                                      {
                                                                        key:
                                                                          jour.id +
                                                                          regimeId,
                                                                        staticClass:
                                                                          "inputEffectif",
                                                                        attrs: {
                                                                          typeFiltre:
                                                                            "quantiteEntiere",
                                                                          zeroSiVide: true,
                                                                          readonly: _vm.estPasse(
                                                                            i
                                                                          )
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .effectifJour[
                                                                              regimeId
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.effectifJour,
                                                                              regimeId,
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "effectifJour[regimeId]"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        ],
                                        2
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.cotationManquanteJour(
                                            jour.id
                                          )
                                            ? "warningText"
                                            : "",
                                          staticStyle: { "font-weight": "700" }
                                        },
                                        [
                                          _vm.premierServiceSurJour(jour) &&
                                          _vm.premierServiceSurJour(jour)
                                            .jourPlanAlimentaire
                                            ? _c("i", {
                                                staticClass:
                                                  "fas fa-info-circle",
                                                attrs: {
                                                  title:
                                                    "Plan alimentaire '" +
                                                    _vm.premierServiceSurJour(
                                                      jour
                                                    ).nomPlanAlimentaire +
                                                    "' : Jour " +
                                                    _vm.premierServiceSurJour(
                                                      jour
                                                    ).jourPlanAlimentaire
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            " " +
                                              _vm._s(jour.nom.substring(0, 3)) +
                                              ". " +
                                              _vm._s(_vm.jourDate(jour.id))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          key: _vm.keyHeader,
                                          class: _vm.cotationManquanteJour(
                                            jour.id
                                          )
                                            ? "warningText"
                                            : "",
                                          staticStyle: { "font-weight": "700" }
                                        },
                                        [_vm._v(_vm._s(_vm.coutJour(jour.id)))]
                                      )
                                    ],
                                    2
                                  )
                                ])
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.servicesPresents, function(serviceCode) {
                        return [
                          _c(
                            "tr",
                            {
                              key: serviceCode + 1,
                              staticClass: "hover-inactif",
                              staticStyle: {
                                position: "sticky",
                                top: "40px",
                                background: "white",
                                "z-index": "5"
                              },
                              attrs: {
                                id: "service-" + serviceCode,
                                visible: ""
                              }
                            },
                            _vm._l(_vm.servicesActifs(serviceCode), function(
                              service
                            ) {
                              return _c(
                                "td",
                                {
                                  key: service.jour,
                                  class: { pasDeService: !service.composantes }
                                },
                                [
                                  service.composantes
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-center-space-between titre-repas-container bg-mercuriale-light-faible-opacite"
                                        },
                                        [
                                          !_vm.lectureSeule
                                            ? [
                                                _c(
                                                  "button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-modal",
                                                        rawName: "v-b-modal",
                                                        value:
                                                          "changerEffectif" +
                                                          serviceCode +
                                                          service.jour,
                                                        expression:
                                                          "'changerEffectif'+serviceCode+service.jour"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "btn btn-primary btn-sm"
                                                  },
                                                  [
                                                    _c("i", {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName: "v-tooltip",
                                                          value: {
                                                            content:
                                                              "Changer les effectifs du service"
                                                          },
                                                          expression:
                                                            "{ content: 'Changer les effectifs du service'}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "fas fa-users cursor-pointer"
                                                    })
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _c(
                                            "b-modal",
                                            {
                                              attrs: {
                                                id:
                                                  "changerEffectif" +
                                                  serviceCode +
                                                  service.jour,
                                                title: "Effectifs du service",
                                                "ok-title": "Valider",
                                                "cancel-title": "Annuler",
                                                "no-close-on-backdrop": ""
                                              },
                                              on: {
                                                show: function($event) {
                                                  return _vm.initEffectifsService(
                                                    service
                                                  )
                                                },
                                                ok: function($event) {
                                                  return _vm.setEffectifsService(
                                                    service,
                                                    !_vm.effectifsSurServiceUniquement
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "default" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "container-fluid"
                                                    },
                                                    [
                                                      _vm.regimeIds.length === 1
                                                        ? _c("div", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex-center-space-evenly"
                                                              },
                                                              [
                                                                _vm.estPasse(
                                                                  service.decalageJour
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              "Effectif Servi"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        service.id !==
                                                                        -1
                                                                          ? _c(
                                                                              "InputNumber",
                                                                              {
                                                                                key:
                                                                                  "effectifServi" +
                                                                                  service.id,
                                                                                staticClass:
                                                                                  "inputEffectif",
                                                                                attrs: {
                                                                                  typeFiltre:
                                                                                    "quantiteEntiere",
                                                                                  zeroSiVide: true
                                                                                },
                                                                                model: {
                                                                                  value:
                                                                                    _vm.effectifServiService,
                                                                                  callback: function(
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.effectifServiService = $$v
                                                                                  },
                                                                                  expression:
                                                                                    "effectifServiService"
                                                                                }
                                                                              }
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _c(
                                                                  "div",
                                                                  [
                                                                    _c("div", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.estPasse(
                                                                            service.decalageJour
                                                                          )
                                                                            ? "Théorique"
                                                                            : "Effectif prévu"
                                                                        )
                                                                      )
                                                                    ]),
                                                                    service.id !==
                                                                    -1
                                                                      ? _c(
                                                                          "InputNumber",
                                                                          {
                                                                            key:
                                                                              service.id,
                                                                            staticClass:
                                                                              "inputEffectif",
                                                                            attrs: {
                                                                              typeFiltre:
                                                                                "quantiteEntiere",
                                                                              zeroSiVide: true,
                                                                              readonly: _vm.estPasse(
                                                                                service.decalageJour
                                                                              )
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm.effectifService,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.effectifService = $$v
                                                                              },
                                                                              expression:
                                                                                "effectifService"
                                                                            }
                                                                          }
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _vm.effectifService
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "row"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-6"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Régime"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-3"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Effectif Servi"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-3"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.estPasse(
                                                                            service.decalageJour
                                                                          )
                                                                            ? "Théorique"
                                                                            : "Effectif"
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._l(
                                                                _vm.regimeIds,
                                                                function(
                                                                  regimeId
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: regimeId,
                                                                      staticClass:
                                                                        "row",
                                                                      staticStyle: {
                                                                        "margin-top":
                                                                          "10px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "col-6",
                                                                          staticStyle: {
                                                                            "padding-top":
                                                                              "5px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.regimeNom(
                                                                                regimeId
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm.estPasse(
                                                                        service.decalageJour
                                                                      )
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-3"
                                                                            },
                                                                            [
                                                                              service.id !==
                                                                              -1
                                                                                ? _c(
                                                                                    "InputNumber",
                                                                                    {
                                                                                      key:
                                                                                        "effectifServi" +
                                                                                        service.id +
                                                                                        regimeId,
                                                                                      staticClass:
                                                                                        "inputEffectif",
                                                                                      attrs: {
                                                                                        typeFiltre:
                                                                                          "quantiteEntiere",
                                                                                        zeroSiVide: true
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          _vm
                                                                                            .effectifServiService[
                                                                                            regimeId
                                                                                          ],
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm.effectifServiService,
                                                                                            regimeId,
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                        expression:
                                                                                          "effectifServiService[regimeId]"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                : _vm._e()
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "col-3"
                                                                        },
                                                                        [
                                                                          service.id !==
                                                                          -1
                                                                            ? _c(
                                                                                "InputNumber",
                                                                                {
                                                                                  key:
                                                                                    service.id +
                                                                                    regimeId,
                                                                                  staticClass:
                                                                                    "inputEffectif",
                                                                                  attrs: {
                                                                                    typeFiltre:
                                                                                      "quantiteEntiere",
                                                                                    zeroSiVide: true,
                                                                                    readonly: _vm.estPasse(
                                                                                      service.decalageJour
                                                                                    )
                                                                                  },
                                                                                  model: {
                                                                                    value:
                                                                                      _vm
                                                                                        .effectifService[
                                                                                        regimeId
                                                                                      ],
                                                                                    callback: function(
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm.effectifService,
                                                                                        regimeId,
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                    expression:
                                                                                      "effectifService[regimeId]"
                                                                                  }
                                                                                }
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "container-fluid"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12 flex-end"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "label-checkbox mb-2"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.effectifsSurServiceUniquement,
                                                                        expression:
                                                                          "effectifsSurServiceUniquement"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "checkbox"
                                                                    },
                                                                    domProps: {
                                                                      checked: Array.isArray(
                                                                        _vm.effectifsSurServiceUniquement
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm.effectifsSurServiceUniquement,
                                                                            null
                                                                          ) > -1
                                                                        : _vm.effectifsSurServiceUniquement
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm.effectifsSurServiceUniquement,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c = $$el.checked
                                                                            ? true
                                                                            : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v = null,
                                                                            $$i = _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              (_vm.effectifsSurServiceUniquement = $$a.concat(
                                                                                [
                                                                                  $$v
                                                                                ]
                                                                              ))
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              (_vm.effectifsSurServiceUniquement = $$a
                                                                                .slice(
                                                                                  0,
                                                                                  $$i
                                                                                )
                                                                                .concat(
                                                                                  $$a.slice(
                                                                                    $$i +
                                                                                      1
                                                                                  )
                                                                                ))
                                                                          }
                                                                        } else {
                                                                          _vm.effectifsSurServiceUniquement = $$c
                                                                        }
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "ml-2"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Ne pas appliquer sur les composantes"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          ),
                                          _vm.menu.excluEffectifPortage
                                            ? _c("div", [
                                                _vm.estPasse(
                                                  service.decalageJour
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "margin-right": "10px"
                                                        },
                                                        attrs: {
                                                          title:
                                                            "Effectif servi"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-user-check"
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              service.effectifServi
                                                                ? service.effectifServi
                                                                : "?"
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: "Effectif prévu"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fas fa-user"
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(service.effectif)
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              class: _vm.cotationManquanteService(
                                                service
                                              )
                                                ? " warningText"
                                                : "bold600"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.serviceNom(serviceCode)
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              key: _vm.keyHeader,
                                              class: _vm.cotationManquanteService(
                                                service
                                              )
                                                ? " warningText"
                                                : "bold600"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.coutService(service))
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          ),
                          _c(
                            "tr",
                            {
                              key: "case" + serviceCode + 1,
                              staticClass: "hover-inactif",
                              attrs: {
                                id: "caseService-" + serviceCode,
                                visible: ""
                              }
                            },
                            _vm._l(_vm.servicesActifs(serviceCode), function(
                              service
                            ) {
                              return _c(
                                "td",
                                {
                                  key: "case" + service.jour,
                                  class: { pasDeService: !service.composantes }
                                },
                                [
                                  service.composantes
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "composantes-container"
                                        },
                                        _vm._l(service.composantes, function(
                                          composante,
                                          i
                                        ) {
                                          return _c(
                                            "div",
                                            { key: i },
                                            [
                                              _c("CaseMenu", {
                                                ref:
                                                  "case_" +
                                                  service.id +
                                                  "_" +
                                                  composante.cleComposee,
                                                refInFor: true,
                                                attrs: {
                                                  menu: _vm.menu,
                                                  composante: composante,
                                                  service: service,
                                                  regimeIds: _vm.regimeIds,
                                                  textureIds: _vm.textureIds,
                                                  estPasse: _vm.estPasse,
                                                  mode: _vm.mode,
                                                  lectureSeule: _vm.lectureSeule
                                                },
                                                on: {
                                                  "effacer-la-recette":
                                                    _vm.effacerLaRecette,
                                                  "dupliquer-la-recette":
                                                    _vm.dupliquerLaRecette,
                                                  "prix-a-jour": function(
                                                    $event
                                                  ) {
                                                    _vm.keyHeader += 1
                                                  },
                                                  "move-case": function(
                                                    $event
                                                  ) {
                                                    return _vm.moveCase(
                                                      $event,
                                                      "case_" +
                                                        service.id +
                                                        "_" +
                                                        composante.cleComposee
                                                    )
                                                  },
                                                  "effectif-changed":
                                                    _vm.effectifChanged
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    : _c("div", {
                                        staticClass: "composantes-container"
                                      })
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      })
                    ],
                    2
                  )
                ]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }